import { Link, useLocation } from 'wouter';
// Version 1.1.0 - Fixed navigation to Cards page
import { Home, Layers, Upload, Library, Settings } from 'lucide-react';

export default function BottomNav() {
  const [location] = useLocation();

  const navItems = [
    { path: '/', icon: Home, label: '书流' },
    { path: '/cards', icon: Layers, label: '刷知识' },
    { path: '/upload', icon: Upload, label: '上传' },
    { path: '/library', icon: Library, label: '书架' },
    { path: '/settings', icon: Settings, label: '设置' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 glass-strong border-t border-white/10 safe-area-bottom z-50">
      <div className="flex justify-around items-center h-14 max-w-screen-sm mx-auto px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location === item.path;
          
          return (
            <Link key={item.path} href={item.path}>
              <button
                className={`flex flex-col items-center justify-center gap-0.5 px-2 py-1 rounded-lg transition-all ${
                  isActive
                    ? 'text-primary scale-110'
                    : 'text-text-secondary hover:text-text-primary'
                }`}
              >
                <Icon size={20} strokeWidth={isActive ? 2.5 : 2} />
                <span className="text-[10px] font-medium">{item.label}</span>
              </button>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
